import { render, staticRenderFns } from "./accountDataCenter.vue?vue&type=template&id=18bee2b1&scoped=true"
import script from "./accountDataCenter.vue?vue&type=script&lang=js"
export * from "./accountDataCenter.vue?vue&type=script&lang=js"
import style0 from "./accountDataCenter.vue?vue&type=style&index=0&id=18bee2b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bee2b1",
  null
  
)

export default component.exports